import React from 'react';
import Academics from '../components/Academics';

const AcademicsPage = () => {
  return (
    <main className="pt-20">
      <Academics />
    </main>
  );
};

export default AcademicsPage; 